/**
 * This function takes a string argument and returns an integer.
 * If the given integer is null or empty or an invalid integer the provided default value is returned.
 * The default value if omitted or invalid is defaulted to 0.
 *
 * @param {string} mayBeNumber
 * @param {Number} defaultVal
 *
 * @returns {Number}
 */
export function getIntDefaultIfInValid(
  mayBeNumber: string,
  defaultVal: number = 0
): number {
  return mayBeNumber ? parseInt(mayBeNumber, 10) || 0 : defaultVal || 0;
}

export function generateUUID(): string {
  var d = new Date().getTime();
  var d2 =
    (typeof performance !== "undefined" &&
      performance.now &&
      performance.now() * 1000) ||
    0; //Time in microseconds since page-load or 0 if unsupported
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = Math.random() * 16;
    if (d > 0) {
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}

export function popupCenter(url: string, title: string, w: number, h: number) {

  const dualScreenLeft = window.screenLeft !==  undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !==  undefined   ? window.screenTop  : window.screenY;

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight;

    const systemZoom = width / window.screen.availWidth;
    const left = (width - w) / 2 / systemZoom + dualScreenLeft
    const top = (height - h) / 2 / systemZoom + dualScreenTop

  const newWindow = window.open(
    url,
    title,
    "scrollbars=no,status=no,location=no,toolbar=no,menubar=no,width=" +
      w +
      ", height=" +
      h + 
      ", top=" +
      top +
      ", left=" +
      left
  );
  if (newWindow) {
    newWindow.focus();
  }
}

export function formatForRedis(text:string) {
 if(text) return text.replace(/-|_|\+|\./g, function (x) {
    return `\\${x}`;
  });
  else return;
}
export enum UserRoles {
  Edit = "edit",
  Read = "read",
  Write = "write",
}

export function formatUserFilterText(text:string) {
  var result = "";
  let comp = text
    .trim()
    .split(" ")
    .filter((word) => word.length > 2)
    .map((x) => {
      return  "*" + formatForRedis(x) + "*";
    });
  if (comp.length == 0) {
    return result;
  }

  comp.forEach((element) => {
    result += `@firstName:(${element})|@lastName:(${element})|`;
  });
  console.log("comp here", comp);
  result += `@beamIds:{${comp.join("|")}}`;

  return `(${result})`;
}

// export const cudbServiceId   = localStorage.getItem("selectedOrg") || "cudb-live";
